module.exports = "{{{text}}}";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/impl/dropdown/templates/defaultDropdownListItem.hbs
// module id = 661
// module chunks = 0